import React from 'react'
import styled from 'styled-components'

import PoweredByMobileLogo from './PoweredByMobile'
import WinItLogoMobileMenu from './WinitLogoMobileMenu'

const LogoContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  align-items: center;
  margin: 150px 0 0;
`

const MobileLogos = () => {
    return (
      <LogoContainer>
        <PoweredByMobileLogo />
        <WinItLogoMobileMenu />
      </LogoContainer>
    )
}

export default MobileLogos